import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import ColorPicker from 'simple-color-picker'
// import '!style-loader!css-loader!simple-color-picker/src/simple-color-picker.css'
import { assert } from "@/utils/error"

type Color = [number, number, number, number]

@Component
export default class ColorPickerComponent extends Vue {
  @Prop({ required: true })
  value!: Color

  get rgba() {
    const [r, g, b, a] = this.value
    return `rgba(${r * 255}, ${g * 255}, ${b * 255}, ${a})`
  }

  get rgb() {
    const [r, g, b, a] = this.value
    return `rgb(${r * 255}, ${g * 255}, ${b * 255})`
  }

  get hex() {
    const [r, g, b] = this.value
    return `#${hex256(r)}${hex256(g)}${hex256(b)}`
  }

  isOpen = false
  colorPicker!: ColorPicker

  mounted() {
    this.colorPicker = new ColorPicker({
      color: this.hex,
      el: this.$refs.colorPicker as HTMLElement,
    })
    this.colorPicker.onChange(() => {
      const { r, g, b } = this.colorPicker.getRGB()
      this.$emit('input', [r / 255, g / 255, b / 255, this.value[3]])
    })
  }

  beforeDestroy() {
    this.colorPicker.remove()
  }

  toggle(e: MouseEvent) {
    this.isOpen = !this.isOpen
  }

  @Watch('isOpen')
  onIsOpenChange() {
    if (this.isOpen) {
      this.setCloseTrigger()
    } else {
      this.unsetCloseTrigger()
    }
  }

  mousedownOnBody!: (e: MouseEvent) => void

  private setCloseTrigger() {
    this.mousedownOnBody = (e: MouseEvent) => {
      let el = e.target
      while (el) {
        if (el === this.$el) {
          break
        }
        el = (el as Element).parentElement
      }
      if (el == null) {
        this.isOpen = false
      }
    }
    document.body.addEventListener('mousedown', this.mousedownOnBody)
  }

  private unsetCloseTrigger() {
    assert(!!this.mousedownOnBody, 'mousedown handler not set')
    document.body.removeEventListener('mousedown', this.mousedownOnBody)
  }

  get style(): Partial<CSSStyleDeclaration> {
    return {
      backgroundColor: this.rgba,
      borderColor: this.rgb,
    }
  }
}

function hex256(v: number) {
  const i = Math.round(255 * v)
  const s = (256 + i).toString(16)
  return s.substr(-2)
}
